import React, { useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useToasts } from 'react-toast-notifications'
import { useHistory } from 'react-router-dom'

import { EntityCardProps } from '../../../components/organisms/EntityCard'
import { FilterItem } from '../../../components/organisms/EntityFilter'
import { EntityList } from '../../../components/organisms/EntityList'

import { IGetSpes, IDeleteSpe, ICreateSpe } from '../../../domain/usecases/SPE'
import { filtersFactory } from '../../../main/factories/filters.factory'
import { getEntitiesCount } from '../../../domain/usecases/Reports'
import { convertSpeToEntity } from '../../../domain/converters/SPE'
import { DeleteModal } from '../../../components/molecules/DeleteModal'
import { useDispatch } from 'react-redux'
import { usePermissions } from '../../../hooks/usePermissions'

type ListSpesProps = {
  remoteGetSpe: IGetSpes
  remoteDeleteSpe: IDeleteSpe
  remoteGetEntitiesCount: getEntitiesCount
  remoteCreateSpe: ICreateSpe
}

const ListSpes = ({
  remoteCreateSpe,
  remoteGetSpe,
  remoteDeleteSpe,
  remoteGetEntitiesCount
}: ListSpesProps) => {
  const { addToast } = useToasts()
  const history = useHistory()
  const dispatch = useDispatch()
  const { can } = usePermissions()
  const [spes, setSpes] = React.useState<EntityCardProps[]>()
  const [filters, setFilters] = useState<FilterItem[]>([])

  const [selectedId, setSelectedId] = useState('')
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const RedirectToSpeDetails = (id: string) => {
    history.push(`/spes/${id}`)
  }

  const deleteSpeFunction = (idSpe: string) => {
    handleShow()
    setSelectedId(idSpe)
  }

  const handleDelete = () => {
    remoteDeleteSpe
      .deleteById({ id: selectedId })
      .then((res) => {
        loadData()
        handleClose()
      })
      .catch((error) => {
        handleClose()
        addToast(error.message, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  const loadData = React.useCallback(async () => {
    /*eslint-disable */
    try {
      const SpeResponse = await remoteGetSpe.getAll()
      setSpes(
        convertSpeToEntity(
          SpeResponse,
          can.delete('spes') ? deleteSpeFunction : undefined,
          can.read('spes') ? RedirectToSpeDetails : undefined,
          undefined // Photo upload removed
        )
      )
    } catch (error) {
      addToast('Não foi possivel carregar as SPEs.', {
        appearance: 'error',
        autoDismiss: true
      })
    }
    /*eslint-disable */
  }, [can])

  React.useEffect(() => {
    loadData()
    remoteGetEntitiesCount
      .getEntitiesCount()
      .then((entitiesCount) =>
        setFilters(filtersFactory(entitiesCount, history))
      )
  }, [])

  return (
    <>
      <DeleteModal
        show={show}
        handleClose={handleClose}
        handleOk={handleDelete}
      />
      <EntityList
        title="SPEs"
        activeFilter={1}
        buttons={
          can.create('spes') ? (
            <Button
              onClick={() => history.push(`/spes/create`)}
              variant="primary"
            >
              Adicionar SPE
            </Button>
          ) : null
        }
        filters={filters}
        entityCards={spes}
      />
    </>
  )
}

export default ListSpes
